import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-trans-log-type-multiselect-dropdown',
  templateUrl: './trans-log-type-multiselect-dropdown.component.html',
  styleUrl: './trans-log-type-multiselect-dropdown.component.scss'
})
export class TransLogTypeMultiselectDropdownComponent {

  @Input() oldSelectedValues: any = []
  @Input() dataSource: any[] = []
  @Input() label:string = "Common.TransType"
  @Output() addToList: EventEmitter<any> = new EventEmitter();
  @Output() onType: EventEmitter<any> = new EventEmitter();
  @ViewChild('multiselectElement') multiselectElement :ElementRef|any
  selectedValues: any = []

  timeOut:any=0

  constructor() { }

  ngOnInit(): void {
    if(this.oldSelectedValues.length){
      this.selectedValues = this.oldSelectedValues
    }
  }

  /*----------------------Functions Called from parent---------------------- */
  // setValue(data){
  //   // console.log("eventdata",data)
  //   this.userVal = `[${data.Service_Id}] - ${data.Service_Id}`;
  // }

  typeHandle(event: any) {
    this.onType.emit(event)
  }

  removeValueFromSelected(id:string){
    this.multiselectElement.removeValueFromSelected(id)
  }

  reset(){
    this.selectedValues = []
    this.addToList.emit([])
  }

  /*----------------------when Choosing User---------------------- */
  selectItem($event: any) {
    this.selectedValues = $event
    let itemsIds = this.selectedValues.map((i:any)=>i._id)
    this.addToList.emit(itemsIds)
  }
}
